export default __webpack_public_path__ + "static/media/SD.73b28dc2.svg";